import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ApprovalMethodNoticePeriodField } from '~/components/agreement-controllers/ApprovalMethodNoticePeriodField/ApprovalMethodNoticePeriodField';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { approvalMethodNoticePeriodModel } from '~/models';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export const GetAutoApproveOutOfScopeChargesCellTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            AutoApproveOutOfScopeChargesCellTID: {
                Field: 'invoices-auto-approval',
                Modal: 'edit-auto-approve-out-of-scope-charges-modal',
                EditCell: (index)=>index != null ? "edit-auto-approve-out-of-scope-charges-".concat(index) : '',
                Value: (index)=>index != null ? "auto-approve-out-of-scope-charges-".concat(index) : ''
            }
        }
    });
const AutoApproveOutOfScopeChargesModalContent = (param)=>{
    let { draft, setDraft } = param;
    const { t: cellsTexts } = useLocaleKeys('pages.draftsDashboard.cells');
    const userInfo = useStore((state)=>state.userInfo);
    const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
    const { AutoApproveOutOfScopeChargesCellTID } = useMemo(()=>GetAutoApproveOutOfScopeChargesCellTID(), []);
    const invoiceAutoApproval = useMemo(()=>{
        var _worksAt_settings;
        const invoicesApprovalMethod = draft.invoicesApprovalMethod();
        if (invoicesApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod);
        if (worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.invoicesApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.invoicesApprovalMethod);
        return false;
    }, [
        draft,
        worksAt
    ]);
    const defaultAutoApproveOutOfScopeCharges = draft.defaultAutoApproveOutOfScopeCharges(worksAt);
    const invoiceAutoApprovalNoticePeriod = useMemo(()=>{
        var _worksAt_settings;
        const invoicesApprovalMethod = draft.invoicesApprovalMethod();
        if (invoicesApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod)) return invoicesApprovalMethod.auto.noticePeriodDays;
        if ((worksAt === null || worksAt === void 0 ? void 0 : (_worksAt_settings = worksAt.settings) === null || _worksAt_settings === void 0 ? void 0 : _worksAt_settings.invoicesApprovalMethod) && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.invoicesApprovalMethod)) return worksAt.settings.invoicesApprovalMethod.auto.noticePeriodDays;
        return 30;
    }, [
        draft,
        worksAt
    ]);
    const getApprovalMethodNoticePeriod = (noticePeriodDays)=>({
            type: 'auto',
            auto: {
                noticePeriodDays
            }
        });
    const manualApprovalMethod = {
        type: 'manual'
    };
    return /*#__PURE__*/ _jsx(ApprovalMethodNoticePeriodField, {
        info: cellsTexts.autoApproveOutOfScopeInfo(),
        text: cellsTexts.autoApproveOutOfScope(),
        testId: AutoApproveOutOfScopeChargesCellTID.Field(),
        bi: {
            enabledCheckbox: {
                name: 'invoices_auto_approval_enabled'
            },
            periodSelect: {
                name: 'invoices_auto_approval_period'
            }
        },
        enabled: invoiceAutoApproval,
        onToggle: ()=>{
            const newDraft = invoiceAutoApproval ? draft.setInvoicesApprovalMethod(manualApprovalMethod) : draft.setInvoicesApprovalMethod(getApprovalMethodNoticePeriod(defaultAutoApproveOutOfScopeCharges));
            setDraft(newDraft);
        },
        noticePeriod: invoiceAutoApprovalNoticePeriod,
        onChangePeriod: (noticePeriod)=>{
            setDraft(draft.setInvoicesApprovalMethod(getApprovalMethodNoticePeriod(Number(noticePeriod))));
        }
    });
};
export default function AutoApproveOutOfScopeChargesCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { AutoApproveOutOfScopeChargesCellTID } = useMemo(()=>GetAutoApproveOutOfScopeChargesCellTID(), []);
    const invoicesApprovalMethod = draft.invoicesApprovalMethod();
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.autoApproveOutOfScopeCharges(),
                    testId: AutoApproveOutOfScopeChargesCellTID.Modal(),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AutoApproveOutOfScopeChargesModalContent, {
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: AutoApproveOutOfScopeChargesCellTID.EditCell(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: AutoApproveOutOfScopeChargesCellTID.Value(index),
            children: invoicesApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(invoicesApprovalMethod) ? draftCellsTexts.autoApprovalNoticePeriod({
                count: invoicesApprovalMethod.auto.noticePeriodDays
            }) : draftCellsTexts.autoApprovalDisabled()
        })
    });
}
